<template>
  <v-card tile min-height="700">
    <v-card-title class="pl-0">
      <v-icon color="cyan" class="mdi-rotate-90" large>mdi-window-minimize</v-icon>积分充值
    </v-card-title>
    <v-card-text style="padding-left:100px;padding-top:100px;">
      <v-row justify="center">
        <v-col cols="auto" class="text-center">
          <v-icon class="teal--text" style="font-size:96px;">mdi-check-circle</v-icon>
          <p class="text-h3 teal--text mt-8">正在更新充值订单状态...</p>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import { getPointOrderDetailByTradeNo } from '@/plugins/api'

export default {
  created () {
    let tradeNo = this.$route.query.tradeNo
    this.doLoadOrderFinalStatus(tradeNo)
  },
  methods: {
    async doLoadOrderFinalStatus (tradeNo) { // 循环刷新订单状态
      let times = 0 // 最多刷10次
      let timer = setInterval(async () => {
        await getPointOrderDetailByTradeNo(tradeNo).then(res => {
          let status = res.data.status
          times++
          if (status) {
            clearInterval(timer)
            timer = undefined
            this.$router.push('/profile/point/order/success')
          } else {
            if (times >= 10) { // 跳转到未知错误页面,可能支付成功了,但是回调没执行到
              clearInterval(timer)
              timer = undefined
              // TODO 目前先一直刷,一直等待后端回调执行成功
            }
          }
        })
      }, 2000)
    }
  }
}
</script>